import React, { useContext } from 'react';
import { MousePositionedTooltip } from '@keen.io/ui-core';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { BarSettings, LineSettings, FunnelSettings, ChoroplethSettings, TableSettings, MetricSettings, HeatmapSettings, GaugeSettings, CircularSettings, ComponentSettingsNotAvailable } from './components';
import SettingsContainer from '../SettingsContainer';
import { AppContext } from '../../contexts';

var getSettingsComponent = function getSettingsComponent(widgetType) {
  switch (widgetType) {
    case 'table':
      return TableSettings;

    case 'metric':
      return MetricSettings;

    case 'bar':
      return BarSettings;

    case 'line':
    case 'area':
      return LineSettings;

    case 'heatmap':
      return HeatmapSettings;

    case 'funnel':
      return FunnelSettings;

    case 'pie':
    case 'donut':
      return CircularSettings;

    case 'choropleth':
      return ChoroplethSettings;

    case 'gauge':
      return GaugeSettings;

    default:
      return null;
  }
};

var ComponentSettings = function ComponentSettings(_ref) {
  var widgetType = _ref.widgetType,
      chartSettings = _ref.chartSettings,
      widgetSettings = _ref.widgetSettings,
      onUpdateWidgetSettings = _ref.onUpdateWidgetSettings,
      onUpdateChartSettings = _ref.onUpdateChartSettings,
      componentSettingsConfig = _ref.componentSettingsConfig,
      analysisResult = _ref.analysisResult;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var isDisabled = componentSettingsConfig.isDisabled;
  var hiddenOptions = componentSettingsConfig.hiddenOptions;
  var settingsComponent = getSettingsComponent(widgetType);
  var settingsAreAvailable = widgetType !== 'json';
  return settingsComponent && settingsAreAvailable ? React.createElement(MousePositionedTooltip, {
    isActive: !!isDisabled,
    tooltipPortal: modalContainer,
    tooltipTheme: "dark",
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body2",
        color: colors.white[500]
      }, isDisabled);
    }
  }, React.createElement(SettingsContainer, {
    isDisabled: !!isDisabled
  }, React.createElement(settingsComponent, {
    chartSettings: chartSettings,
    widgetSettings: widgetSettings,
    onUpdateWidgetSettings: onUpdateWidgetSettings,
    onUpdateChartSettings: onUpdateChartSettings,
    hiddenOptions: hiddenOptions,
    analysisResult: analysisResult
  }))) : React.createElement(ComponentSettingsNotAvailable, {
    widgetType: widgetType
  });
};

export default ComponentSettings;